@if (isOpen) {
  <div
    class="absolute right-0 top-full z-20 mt-2 flex w-[162px] flex-col rounded-lg bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.05),0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)]"
    [ngClass]="compact ? 'gap-0.5 p-1.5' : 'gap-2 p-4'"
    role="menu"
  >
    @for (item of items; track item.id) {
      <button
        type="button"
        class="flex cursor-pointer items-center gap-2 rounded-md text-left text-sm leading-4 hover:bg-slate50"
        [ngClass]="[
          item.tone === 'danger' ? 'text-red700' : 'text-slate900',
          compact ? 'px-2.5 py-2' : 'px-4 py-2'
        ]"
        role="menuitem"
        (click)="selectItem(item)"
      >
        @if (item.icon) {
          <app-icon-reusable
            class="flex shrink-0 items-center justify-center"
            [icon]="item.icon"
            [size]="18"
          ></app-icon-reusable>
        }
        {{ item.label }}
      </button>
    }
  </div>
}
